import { render } from "./ContentLink.vue?vue&type=template&id=2a65ee25&ts=true"
import script from "./ContentLink.vue?vue&type=script&lang=ts"
export * from "./ContentLink.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__